import React from "react";
import ZestVideoPlayer from "~/common/videoPlayer/ZestVideoPlayer";
import ContentLegalDisclaimer from "~/common/ContentLegalDisclaimer/ContentLegalDisclaimer";
import { Video } from "~/common/Store/models/Video";
import { SocialMediaShareData } from "~/common/SocialMediaShare/SocialMediaShareData";
import PostTitleSection from "../Shared/Components/PostTitleSection";

interface Props {
  article: {
    id: number;
    showHeaderTitleTop: boolean;
    categoryName: string;
    dateModified: string;
    rawContent: string;
    alt: string;
    headerImagePath: string;
    title: string;
    socialMediaButtons: SocialMediaShareData[];
    relatedResources: {
      header: string;
      imagePath: string;
      content: string;
      link: string;
    }[];
    headerVideo: Video;
  };
  displayHeader: string;
  topicUrl: string;
}

export default function FoodServiceResourcesArticle({
  article,
  displayHeader,
  topicUrl,
}: Readonly<Props>) {
  const {
    showHeaderTitleTop,
    categoryName,
    dateModified,
    rawContent,
    alt,
    headerImagePath,
    socialMediaButtons,
    relatedResources,
    headerVideo,
  } = article;

  return (
    <div data-module="foodServiceResourcesArticle">
      <div className="fsr-content-wrap fsr-articles" id="article">
        <div className="article-box">
          {headerVideo ? (
            <ZestVideoPlayer
              posterImage={headerVideo.poster}
              sources={headerVideo.sources}
              currentIndex={0}
              selected={0}
              activePlayer={false}
              youtubeId={headerVideo.youtubeId}
              useCdn
              playsInline
              closedCaptionsrc={headerVideo.closedCaptionFile}
            />
          ) : (
            <div className="header-image">
              <img className="hero-image" src={headerImagePath} alt={alt} />
            </div>
          )}
          <PostTitleSection
            {...{
              additionalHeaderClasses: "!py-0",
              categories: [{ name: categoryName, url: topicUrl }],
              dateModified,
              displayHeader,
              showHeaderTitleTop,
              socialMediaButtons,
            }}
          />
          <div className="section">
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{ __html: rawContent }} />

            <hr />

            <aside className="pquote">
              <blockquote>
                <ContentLegalDisclaimer alignTextClassName="text-left" />
              </blockquote>
            </aside>
          </div>
        </div>
      </div>
      {relatedResources.length > 0 && (
        <div className="fsr-content-wrap">
          <p className="header-2">Related Resources</p>
          <div className="fsr-flex">
            {relatedResources.map(
              ({ link, imagePath, header, content }, index) => (
                <a
                  href={link}
                  className="fsr-item fsr-flex"
                  // eslint-disable-next-line react/no-array-index-key
                  key={`FsrArticleRelatedReource-${index}`}
                >
                  <span className="fsr-img">
                    <img src={imagePath} alt="" />
                  </span>
                  <span className="fsr-text">
                    <p className="resource-title">{header}</p>
                    <p className="resource-brief">{content}</p>
                  </span>
                </a>
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
}
